import React from "react";
import {
  Table,
  Button,
  Switch,
  Popconfirm,
  Tooltip,
  Spin,
  Tag,
  notification,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { getCorporateGroups } from "../../Graphs/CorporateGroups/lsitCorporateGroups";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AddCorporateUser } from "./AddCorporate";
import { EditForm } from "./EditFrom";
import { auth } from "firebase";
import { ChangePassowordModal } from "./ChangePassswordModal";
import { checkPermission } from "../AdminUser/CheckPremission";
import { changeStatus } from "../../Graphs/CorporateGroups/changeStatus";
import { listCourse } from "../../Graphs/CorporateGroups/listCourse";
import { deleteCorporate } from "../../Graphs/CorporateGroups/deletecourporategroup";
import { searchCorporateGroupUser } from "../../Graphs/CorporateGroups/searchGroup";

class CorporateGroupTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      selectedItem: null, // Store the selected item
      visible: false,
      passvisible: false,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    };
  }

  changePasswordmodalRef;

  async componentDidMount() {
    this.fetchData();
  }

  // listSearchUserData = async (start, end) => {
  //     try {
  //       const {
  //         authToken,
  //         history,
  //         setLoginFlag,
  //         setUserData,
  //         setUserToken,
  //         setCorporateGroupData,
  //         setCorporateGroupDataTotal,
  //         searchText,
  //       } = this.props;
  //       this.setState({
  //         isLoading: true,
  //       });

  //       let userData = await searchCorporateGroupUser(
  //         authToken,
  //         searchText,
  //         start,
  //         end,
  //         "Teacher"
  //       );

  //       if (userData.status === 200) {
  //         //set user Data
  //         await setCorporateGroupData(userData.data);
  //         // await setListUserData(userData.data.docs);
  //         await setCorporateGroupDataTotal(userData.total);

  //         this.setState({
  //           isLoading: false,
  //           data: userData.data,
  //           // data: userData.data.docs,
  //         });
  //       } else if (userData.status == 401) {
  //         await setLoginFlag(false);
  //         await setUserData(null);
  //         await setUserToken(null);
  //         history.push(`${process.env.PUBLIC_URL}/login`);
  //       }
  //     } catch (e) {
  //       console.log("!!!!!!!list search user Data printed here", e);
  //     } finally {
  //       this.setState({
  //         isLoading: false,
  //       });
  //     }
  //   };

  fetchData = async (pagination = this.state.pagination) => {
    const {
      authToken,
      searchQuery,
      setlistCorporateGroup,
      setlistCorporateGroupTotal,
    } = this.props;
    const skipNumber = (pagination.current - 1) * pagination.pageSize;
    const limitNumber = pagination.pageSize;

    this.setState({ isLoading: true });

    try {
      const response = await getCorporateGroups(
        authToken,
        skipNumber,
        limitNumber,
        searchQuery
      );
      // console.log(response)
      if (response.status === 200) {
        setlistCorporateGroup(response.data); // Store corporate group details in Redux
        setlistCorporateGroupTotal(response.total);

        this.setState({
          data: response.data,
          pagination: {
            ...pagination,
            total: response.total || 0,
          },
          startIndex: skipNumber,
          limitNumber: limitNumber,
          isLoading: false,
        });
      } else {
        throw new Error(response.message || "Failed to fetch data");
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message,
      });
      this.setState({ isLoading: false });
    }
  };

  handleTableChange = (pagination) => {
    this.setState({ pagination }, () => this.fetchData(pagination));
  };

  handleEdit = (item) => {
    // console.log("Edit item:", item);
    // Open modal for editing
  };

  showModal = (item) => {
    // console.log("ANCD", item);
    this.setState({ selectedItem: item, visible: true });
  };

  handleStatusChange = async (item, checked) => {
    const { authToken } = this.props; // Get authToken from props

    try {
      // Optimistically update the UI
      this.setState((prevState) => ({
        data: prevState.data.map((user) =>
          user._id === item._id ? { ...user, is_active: checked } : user
        ),
      }));

      // Call API to update status
      const response = await changeStatus(authToken, item._id, checked);

      if (response.status === 200) {
        notification.success({
          message: "Success",
          description: "Status updated successfully!",
        });
      } else {
        throw new Error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      notification.error({
        message: "Error",
        description: "Failed to update status",
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);

      // Revert UI change if API fails
      this.setState((prevState) => ({
        data: prevState.data.map((user) =>
          user._id === item._id ? { ...user, is_active: !checked } : user
        ),
      }));
    }
  };

  handleDeleteUser = async (id) => {
    const { authToken } = this.props;
    // console.log("ID: ", id)

    try {
      const response = await deleteCorporate(authToken, id);

      notification.success({
        message: "Success",
        description: response.message || "Admin deleted successfully!",
      });

      // Refresh list after delete if needed
      // this.fetchAdminList();
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message || "Failed to delete admin",
      });
    }

    setTimeout(() => {
      window.location.reload();
    }, 1000);

    await this.fetchData();
  };

  showChangePasswordModal(item) {
    // console.log("open modal", item);
    this.changePasswordmodalRef.show();
    this.setState({ selectedItem: item });
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
      selectedType: "",
    });
    this.fetchData();
  };

  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      render: (text, item, index) => (
        <div>{index + 1 + this.state.startIndex}</div>
      ),
    },
    {
      title: "Corporate Group Name",
      key: "name",
      render: (text, item) => (
        <Tooltip title="Group Name">
          <div>
            {" "}
            <strong> {item.group_name || `${item.first_name || ""} ${item.last_name || ""}`.trim() || "-"} </strong>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Total Department",
      key: "total_department",
      render: (text, item) => (
        <Tooltip title="Department">
          {/* <Tag color={item.type === "private" ? "blue" : "green"}> */}
          {item.total_department || 0}
          {/* </Tag> */}
        </Tooltip>
      ),
    },
    {
      title: "Total Courses",
      key: "total_courses",
      render: (text, item) => (
        <Tooltip title="Total Courses assigned to group">
          {item.total_courses ?? 0}
        </Tooltip>
      ),
    },
    {
      title: "Active",
      key: "is_active",
      render: (text, item) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "corporate_group", "edit");
        return (
          <Switch
            checked={item.is_active}
            onChange={(checked) => this.handleStatusChange(item, checked)}
            disabled={!canEdit}
          />
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, item) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "corporate_group", "edit");
        const canDelete = checkPermission(loginUserData, "corporate_group", "delete");
        return (
          <div ml="15px" mr="5px" style={{ float: "left", marginLeft: "20px" }}>
            <Link to={`/corporategroupaction/${item._id}`}>
              <Tooltip placement="bottom" title="View Course">
                <Button shape="circle" icon={<EyeOutlined />} />
              </Tooltip>
            </Link>
            {canEdit && (
              <div mr="5px" style={{ float: "left", marginLeft: "10px" }}>
                <Tooltip placement="bottom" title="Edit">
                  <Button
                    shape="circle"
                    icon={<EditOutlined />}
                    onClick={() => {
                      this.showModal(item);
                    }}
                  />
                </Tooltip>
              </div>
            )}
            {canEdit && (
              <div mr="5px" style={{ float: "left", marginLeft: "10px" }}>
                <Tooltip placement="bottom" title="Change Password">
                  <Button
                    shape="circle"
                    icon={<LockOutlined />}
                    onClick={() => {
                      this.showChangePasswordModal(item);
                    }}
                  />
                </Tooltip>
              </div>
            )}
            {canDelete && (
              <div
                ml="15px"
                mr="5px"
                style={{ float: "left", marginLeft: "10px", marginRight: "10px" }}
              >
                <Tooltip placement="bottom" title="Delete">
                  <Popconfirm
                    // onConfirm={this.deleteUserData.bind(this, item)}
                    title="Are you sure you want to delete User?"
                    onConfirm={() => this.handleDeleteUser(item._id)}
                  >
                    <Button shape="circle" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  render() {
    const { isLoading, pagination, visible, selectedItem } = this.state;
    const { authToken, data } = this.props;

    console.log("Data: ", data);

    return (
      <>
        {isLoading ? (
          <Spin size="large" style={{ margin: "50px" }} />
        ) : (
          <Table
            rowKey="_id"
            columns={this.columns}
            dataSource={data || []}
            pagination={pagination}
            onChange={this.handleTableChange}
            locale={{ emptyText: "No data available" }}
          />
        )}

        {/* Edit Corporate Group Modal */}
        <EditForm
          visible={visible} // Pass state from CorporateGroupTable
          onCancel={this.handleCancel} // Handle close from CorporateGroupTable
          item={selectedItem}
          itemId={selectedItem && selectedItem._id}
          Token={this.props.authToken}
        />

        <ChangePassowordModal
          refx={(e) => (this.changePasswordmodalRef = e)}
          onClose={this.handleCancel}
          item={selectedItem}
          itemId={selectedItem && selectedItem._id}
          onChangePassword={this.handleChangePassword}
          Token={this.props.authToken}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
  searchQuery: state.group.searchQuery,
  data: state.corporateGroup.listCorporateGroup,
});

const mapDispatchToProps = (dispatch) => ({
  setLoginFlag: (flag) => dispatch({ type: "SET_LOGIN_FLAG", flag }),
  setUserData: (userData) => dispatch({ type: "SET_USER_DATA", userData }),
  setUserToken: (authToken) =>
    dispatch({ type: "SET_USER_AUTHTOKEN", authToken }),
  setlistCorporateGroup: (listCorporateGroup) => {
    dispatch({
      type: "SET_LIST_CORPORATE_GROUP_DATA",
      listCorporateGroup: listCorporateGroup,
    });
  },
  setlistCorporateGroupTotal: (corporateGroupsTotal) => {
    dispatch({
      type: "SET_LIST_CORPORATE_GROUP_DATA_TOTAL",
      setlistCorporateGroupTotal: corporateGroupsTotal,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CorporateGroupTable));
